import template from './employee_leave.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeLeaveViewModel
{
	constructor(page)
	{
		this.employee = ko.observable(); 
		this.page = page;
		this.is_viewing_own_profile = ko.observable('true');
		this.pending_resignation = ko.observable(false);
		this.registered_status = ko.observable();
	}

	async load_employee()
	{
		this.employee(null);
		this.pending_resignation(false);
		let employee_id = Utils.current_employee_id();

		let res = await Grape.fetches.getJSON('/employee/' + employee_id, {});

		// get registered_status
		this.registered_status(res.employee.registered_status);
		let employee = res.employee;
		this.employee(employee);

		Utils.refresh_data_visible_roles();
	}
}

class EmployeeLeavePage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EmployeeLeaveViewModel(this);
		document.title = tr('My Leave');
		window.current_page_title(tr('My Leave'));
	}

	async init()
	{
		document.title = 'Search employee...';
	}

	async updateData()
	{
		await this.viewModel.load_employee();
	}
}

export default {
	route: '[/]employee/leave',
	page_class: EmployeeLeavePage,
	template: template,
	template_filename: 'translation/employee_leave'
};
